export const decisionTool = {
  guidelines: {
    header: "Directives",
    guidelinesPre: "Voici quelques directives avant d'utiliser cet outil :",
    guidelines1:
      "L'outil d'aide à la prise de décision fournit une visualisation simplifiée des parties d'une image qui ont le plus d'influence sur la décision du modèle (carte de saillance). Toutefois, il ne représente pas toujours avec précision le raisonnement complexe derrière les prédictions du modèle.",
    guidelines2:
      "L'outil peut générer des masques différents pour une même image car la technique utilisée est de nature stochastique.",
    guidelines3:
      "Les résultats de l'outil de suggestion et d'aide à la décision peuvent différer car l'outil d'aide à la décision produit un masque pour une image à la fois, tandis que les suggestions sont la moyenne des prédictions pour toutes les images.",
    guidelines4:
      "Certains défauts ne sont pas représentés car leur niveau de confiance est trop faible.",
  },
  notice: {
    header: "Avertissement",
    noticeText:
      "Les modèles de classifications peuvent fournir des informations précieuses, cependant il est important de reconnaître leurs limites et d'interpréter les résultats avec prudence, en particulier dans les scénarios complexes ou à fort enjeu.",
  },
};
